import { get, writable } from "svelte/store";
import { getCredentialsForIceServers } from "../services/iceServers";
import { getStunChoice } from "../utils/getStunChoice";
import { getWebRTCConfiguration } from "../utils/getWebRTCConfiguration";
import { buildLog } from "../utils/log";
import { sendSocketMessage } from "./socketStore";
import { ROOM_CONNECTION_STATE } from "../types/Room/RoomConnectionState";
import { getRoom } from "./roomStore";
import { remoteAudioStore, remoteVideoStore } from "./remoteVideoStore";
import "./toastStore";
export const peerConnectionWithClientStore = writable(null);
export const pendingIceWithClientStore = writable([]);
export async function createPeerConnectionWithClient(roomId) {
    console.log("[createPeerConnectionWithClient] createPeerConnection roomId", roomId);
    const oldPc = get(peerConnectionWithClientStore);
    if (oldPc) {
        oldPc.close();
        peerConnectionWithClientStore.set(null);
    }
    const credentials = await getCredentialsForIceServers();
    const stunChoice = getStunChoice(roomId);
    const configuration = getWebRTCConfiguration(roomId, credentials);
    const pc = new RTCPeerConnection(configuration);
    buildLog({
        roomId,
        status: ROOM_CONNECTION_STATE.CONNECTING,
        page: "Camera",
        message: `CreatePeerConnectionWithClient created using server: ${stunChoice}.sd-sfr.fr`
    });
    pc.onicecandidate = (e) => {
        if (e.candidate) {
            console.log('[peerConnectionWithClient] onicecandidate');
            sendSocketMessage({
                room: getRoom().id,
                action: "ice",
                type: "candidate",
                label: e.candidate.sdpMLineIndex,
                id: e.candidate.sdpMid,
                candidate: e.candidate.candidate,
                target: "client",
                connectionType: "expert",
            });
        }
    };
    pc.ontrack = (e) => {
        console.log('[peerConnectionWithClient][ontrack] e', e);
        if (e.track.kind === "video") {
            remoteVideoStore.set(new MediaStream([e.track]));
        }
        if (e.track.kind === "audio") {
            remoteAudioStore.set(new MediaStream([e.track]));
        }
    };
    pendingIceWithClientStore.set([]);
    peerConnectionWithClientStore.set(pc);
}
export async function handleOfferWithClient(sdp) {
    console.log('[peerConnectionWithClientStore][handleOfferWithClient] sdp', sdp);
    if (!sdp || !sdp.sdp || !sdp.type) {
        console.warn("handleOfferWithClient: invalid SDP", sdp);
        return;
    }
    const pc = get(peerConnectionWithClientStore);
    console.log('[peerConnectionWithClientStore][handleOfferWithClient] pc', pc);
    if (!pc)
        return;
    await pc.setRemoteDescription(new RTCSessionDescription(sdp));
    const answer = await pc.createAnswer();
    console.log('[peerConnectionWithClientStore][handleOfferWithClient] answer', answer);
    await pc.setLocalDescription(answer);
    console.log('[peerConnectionWithClientStore][handleOfferWithClient] setLocalDescription ok');
    sendSocketMessage({
        room: getRoom().id,
        action: "ICEAnswer",
        type: "connection",
        sdp: answer,
        target: "client",
        connectionType: "expert",
    });
    console.log('[peerConnectionWithClientStore][handleOfferWithClient] ICEAnswer sent');
    const pending = get(pendingIceWithClientStore);
    for (const c of pending)
        await pc.addIceCandidate(c);
    pendingIceWithClientStore.set([]);
}
export async function addIceCandidateWithClient(data) {
    const pc = get(peerConnectionWithClientStore);
    if (!pc)
        return;
    const candidate = new RTCIceCandidate({ candidate: data.candidate, sdpMid: data.id, sdpMLineIndex: data.label });
    if (!pc.remoteDescription)
        pendingIceWithClientStore.update(l => [...l, candidate]);
    else
        await pc.addIceCandidate(candidate);
}
export function closePeerConnectionWithClient() {
    const pc = get(peerConnectionWithClientStore);
    if (!pc)
        return;
    pc.getSenders().forEach(sender => { var _a; return (_a = sender.track) === null || _a === void 0 ? void 0 : _a.stop(); });
    pc.close();
    peerConnectionWithClientStore.set(null);
}
